<template>
  <div class="idc-internal-server-error py-5">
    <div class="content">
      <img src="@/assets/images/500.png" alt="500" width="350" />
      <div content="mt-1">
        <h1>500</h1>
        <h2>Internal server error</h2>
      </div>
        <p>{{$t('errorPage.des')}}</p>
         <p> {{$t('errorPage.please')}} <el-button type="text" @click="previousPage">{{$t('errorPage.previous')}}</el-button>
         <span>{{$t('errorPage.or')}}</span>
        <el-button type="text" @click="$router.push('/')">{{$t('errorPage.homePage')}}</el-button></p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Page500',
    data () {
      return {
        window
      }
    },
    computed: {
      message () {
        return 'The webmaster said that you can not enter this page...'
      }
    },
    methods: {
      previousPage () {
        window.history.back()
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-button--text{
  color: #ff6b6b;
  font-size: 16px;
  &:hover{
    color: #67c23a;
  }
}
.idc-internal-server-error {
  height: 100vh;
  background: #0093ff;
}
.idc-internal-server-error .content {
  width: 400px;
  margin: auto;
  color: #ffffff;
  text-align: center;
}
.content h1 {
  font-size: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/idc/error-page/500.vue